module.exports = __webpack_public_path__ + "static/media/vid1.cbfcead7.mp4";